import React, { useRef } from 'react';
import NotePageHeader from '../../../components/NotePageHeader';
import { useNavigate, useParams } from 'react-router-dom';
import apiClient from '../../../services/apiClient';
import NoteEditor from '../../../components/NoteEditor';
import { useNoteEditorData } from '../../../components/NoteEditPage';
import Spinner from '../../../components/Spinner';
import { getLanguage, t } from '../../../i18n';
import { editorText } from '../../../components/noteEditorText';
import './NoteComposerPage.css';

function NoteComposerPage({ onRefresh }) {
  const { noteId } = useParams();
  const navigate = useNavigate();
  const language = getLanguage();
  const editorRef = useRef(null);
  const { note, loading, error, reload } = useNoteEditorData(noteId);
  const back = () => noteId ? navigate('/map', { state: { noteId } }) : navigate('/notes');

  return <div className="note-composer-page">
    <NotePageHeader title={t(noteId ? 'noteComposer.page.addCardsTitle' : 'noteComposer.page.addNoteTitle', language)}
      description={noteId ? editorText('appendOnly', language) : t('noteComposer.page.createHelp', language)}
      onBack={() => editorRef.current ? editorRef.current.requestCancel() : back()} />
    {loading ? <Spinner size="medium" message={t('noteComposer.page.loading', language)} /> : error ? <div className="composer-page-error" role="alert"><p>{editorText('loadFailed')} {error}</p><button type="button" onClick={reload}>{editorText('retry')}</button></div> :
      <NoteEditor ref={editorRef} key={noteId || 'new'} initialNote={note || {}} mode={noteId ? 'edit' : 'create'} appendOnly={Boolean(noteId)} onCancel={back} onSaved={back} onSave={async (payload) => {
        if (noteId) await apiClient.updateNoteContent(noteId, payload);
        else await apiClient.composeNote(payload);
        // A refresh failure must not turn a committed save into a duplicate-create retry.
        try { await onRefresh?.(); } catch { /* The destination can reload its own data. */ }
      }} />}
  </div>;
}

export default NoteComposerPage;
